export default __webpack_public_path__ + "static/media/examination_open_sidebar.e5db80cf.svg";